import type { ButtonIconProps } from ".";

export const getIconSize = (variant: ButtonIconProps["variant"], size: ButtonIconProps["size"]) => {
	if (variant === "standard") {
		return size;
	} else if (variant === "outline" || variant === "ghost") {
		return 16;
	}
};
